module.exports = __webpack_public_path__ + "img/stamp1.67fdb2be.jpg";